/**
  * Debounce helper
  * @param {Function} fn Function to be debounced
  * @param {int} delay Delay of function call
  */
export default (fn, delay) => {
  let timerId;

  return (...args) => {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      fn(...args);
      timerId = null;
    }, delay);
  };
};
